import { createContext, useContext, useState } from 'react'

const ActivityLogSidebarContext = createContext(null)

const ActivityLogSidebarContextProvider = ({ children }) => {
  const [selectedTab, setSelectedTab] = useState<string | null>('HIRING_STEPS')

  return (
    <ActivityLogSidebarContext.Provider
      value={{
        selectedTab,
        setSelectedTab,
      }}
    >
      {children}
    </ActivityLogSidebarContext.Provider>
  )
}

export function useActivityLogSidebarContext() {
  return useContext(ActivityLogSidebarContext)
}

export { ActivityLogSidebarContext, ActivityLogSidebarContextProvider }
